module.exports = __webpack_public_path__ + "img/img_t3@2x.37f626d3.png";